import { Injectable,ViewChild, ElementRef } from '@angular/core';
 import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx'; 
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { SendReportEmailComponent } from '../send-report-email/send-report-email.component';
import { saveAs } from 'file-saver';
 
// import jsPDF from 'jspdf'
// import 'jspdf-autotable'

@Injectable()
export class ExportService {
  @ViewChild('pdfTable', {static: false}) pdfTable: ElementRef;
  fileName= 'EliHealtExcelSheet.xlsx'; 
  images: any;
  public loaderComp:any


  constructor( public dialog: MatDialog,private authService:AuthService,private opdvisitService:OpdVisitService) { }

  exportxcel(element) 
    {
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element ,{raw:true});
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
       
       XLSX.writeFile(wb, this.fileName);
			
    }
    exportexcelwithcolor(){
      
    }
    Newexportxcel(element,name) 
    { 
     
      var fileName = `${name}.xlsx`;
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
       XLSX.writeFile(wb,fileName);
       const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

       // Convert the binary string to a Blob
       const blob = new Blob([wbout], { type: 'application/octet-stream' });
   
       // Convert the Blob to Base64
       const reader = new FileReader();
       reader.readAsDataURL(blob);
       reader.onloadend = () => {
         const base64data = reader.result as string;
       this.openemailsentMaster(base64data.split(',')[1],`${name}.xlsx`,'application/octet-stream');
       };
       this.loaderComp.close();
     
    }
    
 
  public CreatePDF(DATA) {
     
      html2canvas(DATA).then(canvas => {
         let fileWidth = 208;
        let fileHeight = canvas.height * fileWidth / canvas.width;
        const FILEURI = canvas.toDataURL('image/png')
        let PDF = new jsPDF('p', 'mm', 'a4');
        let position = 0;
        PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
         PDF.save('EliHealt.pdf');
         this.loaderComp.close();
    });     
  }

  printData(cmpName) {
     let originalContents = document.body.innerHTML;
    document.body.innerHTML = cmpName;
    window.print();
    document.body.innerHTML = originalContents;
    this.loaderComp.close();
   }

   exportPDF(data){
    // var data = document.getElementById('contentToConvert');  
    html2canvas(data).then(canvas => {  
      // Few necessary setting options  
      var imgWidth = 209;   
      var pageHeight = 295;    
      var imgHeight = canvas.height * imgWidth / canvas.width;  
      var heightLeft = imgHeight;  
  
      const contentDataURL = canvas.toDataURL('image/png')  
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF  
      var position = 0;  
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)  
      pdf.save('EliHealt.pdf'); // Generated PDF   
    });   
    this.loaderComp.close();

   }

   

//var base64 = (document.getElementById("imageid"));
download(data){
  html2canvas(data).then(canvas => {  
  var imgData = canvas.toDataURL('image/png');
  var imgWidth = 210;
  var pageHeight = 295;
  var imgHeight = canvas.height * imgWidth / canvas.width;
  var heightLeft = imgHeight;

  var doc = new jsPDF('p', 'mm', "a4");
  var position = 0;

  doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight+10);
  heightLeft -= pageHeight;

  while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight+10);
      heightLeft -= pageHeight;
  }

doc.save("EliHealt.pdf");
this.loaderComp.close();
  
});
}

Newdownload(data,name){
  html2canvas(data).then(canvas => {  
  var imgData = canvas.toDataURL('image/png');
  var imgWidth = 210;
  var pageHeight = 295;
  var imgHeight = canvas.height * imgWidth / canvas.width;
  var heightLeft = imgHeight;

  var doc = new jsPDF('p', 'mm', "a4");
  var position = 0;

  doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight+10);
  heightLeft -= pageHeight;

  while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight+10);
      heightLeft -= pageHeight;
  }
  this.loaderComp.close();
doc.save(name);

  
});
}



open_loader_Dialogtwo(): void {
  this.loaderComp = this.dialog.open(SiteloaderComponent, {
     width: '300px',
     panelClass: 'site-loader',
     data: { }
   });

   this.loaderComp.afterClosed().subscribe(result => { });
 }
 
 public convertToPDF(id:any,name:any)
{
  console.log('new5')
html2canvas(document.body).then(canvas => {
const contentDataURL = canvas.toDataURL('image/png')
let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
var width = pdf.internal.pageSize.getWidth();
var height = canvas.height * width / canvas.width;
pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height)
pdf.save(`${name}.pdf`); // Generated PDF
});
this.loaderComp.close();
}

pdfnew(data:any,name:any){
  var element = document.getElementById('content');

var opt = {
margin:   0.25,
filename: `${name}.pdf`,
image:        { type: 'jpeg', quality: 1},
html2canvas:  { scale: 2},
jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
};

this.loaderComp.close();
}


public convetToPDF(val:any,name:any) {
  var data = document.getElementById('content');
  html2canvas(data).then(canvas => {
      // Few necessary setting options
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf.save(`${name}.pdf`); // Generated PDF
      this.loaderComp.close();
  });
}

public generatePDF(val:any,name:any): void {
  var data = document.getElementById('content');
  html2canvas(data, { scale: 3 }).then((canvas) => {
    const imageGeneratedFromTemplate = canvas.toDataURL('image/png');
    const fileWidth = 200;
    const generatedImageHeight = (canvas.height * fileWidth) / canvas.width;
    let PDF = new jsPDF('p', 'mm', 'a4',);
    PDF.addImage(imageGeneratedFromTemplate, 'PNG', 0, 5, fileWidth, generatedImageHeight,);
    PDF.html(data)
    PDF.save(`${name}.pdf`);
    this.loaderComp.close();
  });
}

// public downloadAsPDF(a,b) {
//    const doc = new jsPDF('p', 'pt', 'a4');
//   var data = document.getElementById('content');
//   const specialElementHandlers = {
//     '#editor': function (element, renderer) {
//       return true;
//     }
//   };

  
//   doc.fromHTML(data,15,15,{
//     width: 190,
//     theme : 'plain',
//     styles: {
//       fontSize: 12
//     },
//     startY: 150,
//     showHeader: 'never',
//     margins : {
//       top: 20,
//       bottom: 20,
//       left: 30,
//       width: 922
//   },

//     'elementHandlers': specialElementHandlers
//   });

//   doc.save('tableToPdf.pdf');
// }


public downloadAsPDF(a:any,b:any) {
  setTimeout(() => {
  let DATA = document.getElementById('content');

 html2canvas(DATA).then((canvas) => {
  const FILEURI = canvas.toDataURL('image/png');
  let PDF = new jsPDF('p', 'mm', 'a4');
  var fileWidth = PDF.internal.pageSize.getWidth();
  var fileHeight = (canvas.height * fileWidth) / canvas.width;
  let position = 0;
  PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
  PDF.save(`${b}.pdf`);
  this.loaderComp.close();
});
 
}, 300);
}

public getexportPDF(a:any,b:any){
    
  let DATA = document.getElementById('content');
  html2canvas(DATA).then((canvas) => {
    canvas.getContext('2d');
    var HTML_Width = canvas.width;
    var HTML_Height = canvas.height;
    var top_left_margin = 15;
    var PDF_Width = HTML_Width + top_left_margin * 2;
    var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    var canvas_image_width = HTML_Width;
    var canvas_image_height = HTML_Height;

    var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
    console.log(canvas.height + '  ' + canvas.width);

    var imgData = canvas.toDataURL('image/jpeg', 1.0);
    var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
    pdf.addImage(
      imgData,
      'JPG',
      top_left_margin,
      top_left_margin,
      canvas_image_width,
      canvas_image_height
    );

    for (var i = 1; i <= totalPDFPages; i++) {
      pdf.addPage([PDF_Width, PDF_Height]);
      let margin = -(PDF_Height * i) + top_left_margin * 4;
      if (i > 1) {
        margin = margin + i * 8;
      }
     
      pdf.addImage(
        imgData,
        'JPG',
        top_left_margin,
        margin,
        canvas_image_width,
        canvas_image_height
      );
    }
  
   pdf.save(`${b}.pdf`);
    // Convert the Blob to Base64
    const pdfBlob = pdf.output('blob');
    const reader = new FileReader();
    reader.readAsDataURL(pdfBlob);
    reader.onloadend = () => {
      const base64data = reader.result as string;
    this.openemailsentMaster(base64data.split(',')[1],`${b}.pdf`,'application/pdf');
    };
   
    this.loaderComp.close();
    
  });
 
  }
  base64ToBlob(base64: string,filename:any, contentType:any): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], filename, { type: contentType });
  }
 

  openemailsentMaster(base64:any,filename:any,fileformat:any): void{
  
    if(this.opdvisitService.documentrul.length >0){
      const sendmaildefault = this.opdvisitService.documentrul.filter(item => item.propertyName == 'SendEmailOptionInReports');
      if(sendmaildefault[0]?.propertyValue == "Y"){
        const dialogRef = this.dialog.open(SendReportEmailComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "35%",
          width: "30%",
          disableClose: true,
          data:{
            base64data:base64,
            fileName:filename,
            fileFormat:fileformat
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result != 0) {
            
          }
        });
      }
    }
  
  }


printwindow(content:any): void {
  let printContents, popupWin;
  printContents = document.getElementById(content).innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>
        
        
      </head>
  <body onload="window.print();">${printContents}</body>
    </html>`
  );
  popupWin.document.close();
}
 
printpDFData(): void {
  let printContents, popupWin;
  printContents = document.getElementById('content').innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>
      <style>
      @media print{
* {
	outline: none;
	color-adjust: exact;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

.header {
	padding: 10px 10px 0 10px;

}

div {
	line-height: normal;
}

#content {
	font-size: 14px;
}

.print-bg {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 300px;
	z-index: -1;
	width: 100%;
	background-color: #c2d2f1;
}

.print-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	padding: 10px;
	text-align: left;
	font-family: Arial, Helvetica, sans-serif;
    font-size:13px;
}

.print-header ul {
	padding: 0px;
	margin: 0;
	list-style: none;

}

.print-header li {
	padding: 0 0 4px 0;
	margin: 0;

}

.print-header li:first-child {
	margin-bottom: 10px;
}

.print-title {
	background: #fff;
	border: 1px solid #ccc;
	border-bottom: 0;
	padding: 8px 15px;
}

.table-block {
	padding: 0px;

}

table {
	border-spacing: 0;
	border: solid 1px #000;
	border-collapse: collapse;
}

td {
	font-size: 13px !important;
}

td.td-sm {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	background: #fff !important;
}

th {
	background: #fff !important;
	font-size: 13px !important;
}

th.th-sm {
	background: #fff !important;
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}

.table-section {
	display: none !important;
}

.print-header-text {
	display: inline-flex;
	justify-content: start;
	font-family: Arial, Helvetica, sans-serif;
	padding-bottom: 2px;
	font-size: 13px;
}

.print-header-middle {
	width: 200px;
	font-family: Arial, Helvetica, sans-serif;
}

.hospital-name {
	padding-bottom: 5px;
	font-weight: bold;
	font-size: 1.2rem;
	text-transform: uppercase;
}

.address-details {
	font-size: 13px;
}

.address-details ul {
	padding: 0;
	margin: 0;
	list-style: none;

}

.address-details li {
	padding-bottom: 4px;
}

.address-details li:first-child {
	margin-bottom: 0;
}



.print-footer {
	position: fixed;
	right: 0;
	left: 0;
	bottom: 0;
	display: flex;
	padding: 10px;
	text-align: left;
	align-items: center;
	justify-content: space-between;
	background-color: #c2d2f1;
	font-size: 13px;
  font-family: Arial, Helvetica, sans-serif;
}

.print-footer-middle {
	width: 200px;
	font-family: Arial, Helvetica, sans-serif;

}

.print-footer .address-details {
	font-size: 13px;

}

.print-footer .address-details ul {
	padding: 0;
	margin: 0;
	list-style: none;
	display: block;
}

.print-footer .address-details li {
	padding-bottom: 4px;
 
}

.print-footer .address-details li:first-child {
	margin-bottom: 0;
 
}

.print-footer ul {
	padding: 0px;
	margin: 0;
	list-style: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
}

.print-footer ul {
	padding: 0px;
	margin: 0;
	list-style: none;
}

.print-footer li {
	padding: 0 0 4px 0;
	margin: 0;

}

.print-footer li:first-child {
	margin-bottom: 10px;
}
.d-inline-flex {
display:inline-flex;
  }
.justify-content-start{
justify-content:start;
}
.align-items-center{
align-items:center;
}
     }
                </style>
        
      </head>
  <body onload="window.print();">${printContents}</body>
    </html>`
  );
  popupWin.document.close();
}




  exportArrayToExcel(data: any[], fileName: string): void {
    // 1. Convert array to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
 
    // 2. Create a new workbook and append the worksheet
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    worksheet['!cols'] = [
      { wch: 13 }, 
      { wch: 11 },
      { wch: 20 }, 
      { wch: 11 }, 
      { wch: 20 }, 
      { wch: 14 },
      { wch: 10 },
    ];
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
 
    // 3. Write the workbook to a buffer
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
 
    // 4. Save the file
    this.saveAsExcelFile(excelBuffer, fileName);
  }
 
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, `${fileName}.xlsx`);
  }
}
